module.exports = {
	bannerUserDefaultImage: '',
	bannerGroupDefaultImage: '',
	userDefaultAvatar: '',
	userDefaultAvatarMedium: '',
	userDefaultAvatarSmall: '',
	groupDefaultAvatar: '',
	groupDefaultAvatarMedium: '',
	groupDefaultAvatarSmall: '',
};
